import React, { FC, useEffect, useState, useMemo } from "react";
import { Table, Tooltip } from "antd";
import { ColumnsType } from "antd/es/table";
import { usePurchasePlanModel } from "../purchasePlanModel";
import { IPurchasePlanFields } from "../purchasePlanType"
import { momentFormat, formatNum } from "@/utils/utils";
import { useDictModel } from "@/views/base/dict/dictModel";
import YhTag from "@/components/YhTag";
import useNavModel from "@/model/navModel";
import { tableSize } from "@/utils/constants";
import YhTootip from "@/components/YhTootip";
import { roleColumnModel } from "@/utils/roleColumn";
import useGlobalModel from "@/model/globalModel";

type statusType = {
    "purchase-plan.transfer": string,
    "purchase-plan.create": string,
    [key: string]: any
}

export function DataTable() {

    const {
        dataSource, selectedRowKeys, pgCfg, descRows, descTotal, rowsDescTotal,
        loadData, setSelectedRowKeys, setDescRows, reset
    } = usePurchasePlanModel();
    const { getTreeNodeName } = useDictModel();
    const { selectedNavId, replaceNav, findNav } = useNavModel();
    const { user: { roles } } = useGlobalModel();
    const { getRoleColumns } = roleColumnModel();

    const onLook = (code: string) => {
        let supplierEditKey = "11-1-3";
        replaceNav(
            selectedNavId,
            supplierEditKey,
            { id: code, mode: "look", },
            true
        );
    }
    useEffect(() => {
        loadData();
    }, [])


    const statusColor: statusType = {
        "purchase-plan.transfer": "blue",
        "purchase-plan.create": "cyan",
    }
    const defaultColumns: ColumnsType<IPurchasePlanFields> = [
        {
            title: '序号',
            fixed: "left",
            width: 60,
            render: (t, r, i) => `${i + 1}`,
        }, {
            title: '采购订单号',
            width: 150,
            dataIndex: 'planCode',
            render: (text: any, record: any,) => <YhTootip text={text} onClick={() => onLook(text)} style={{ width: 150 }} />,
            // render: (text: any) => <Tooltip placement="topLeft" title={text}><p className="ellipsis click-span" onClick={(e) =>{e.stopPropagation(); onLook(text)}}>{text}</p></Tooltip>,

        }, {
            title: '单据状态',
            width: 80,
            dataIndex: 'status',
            render: (text) => <YhTag color={statusColor[text]} text={getTreeNodeName(text)} />,
        },
        {
            title: '供应商名称',
            width: 130,
            dataIndex: 'supplierName',
            render: (text: any, record: any,) => <YhTootip text={text} />,
        }, {
            title: '采购批次号',
            width: 120,
            dataIndex: 'batchCode',
            render: (text) => <Tooltip placement="topLeft" title={text}><p className="ellipsis">{text}</p></Tooltip>,
        }, {
            title: '采购审批号',
            width: 120,
            dataIndex: 'orderCode',
            render: (text) => <Tooltip placement="topLeft" title={text}><p className="ellipsis">{text}</p></Tooltip>,
        }, {
            title: '采购类型',
            width: 80,
            dataIndex: 'purchaseTypeName',
            render: (text) => <Tooltip placement="topLeft" title={text}><p className="ellipsis">{text}</p></Tooltip>,
        }, {
            title: '结算类型',
            width: 80,
            dataIndex: 'payType',
            render: (text) => getTreeNodeName(text)
        }, {
            title: '商品类型',
            width: 80,
            dataIndex: 'materialTypeName',
        }, {
            title: '采购数量',
            width: 80,
            dataIndex: 'totalNum',
        }, {
            title: '已到数量',
            width: 140,
            dataIndex: 'arrivedNum',
        }, {
            title: '未到数量',
            width: 80,
            dataIndex: 'unarrivedNum',
            render: (t, r, i) => <span style={{ color: (r.queryType == 2 || r.queryType == 3) ? "red" : "", fontWeight: 'bolder' }}>{t}</span>,
        }, {
            title: '采购总金额',
            width: 130,
            dataIndex: 'totalAmount',
            render: (text) => `￥${formatNum(text)}`
        }, {
            title: '制单日期',
            width: 130,
            dataIndex: 'createTime',
            render: (text) => momentFormat(text)
        }, {
            title: '制单人',
            width: 120,
            dataIndex: 'createUser',
        }, {
            title: '发运方式',
            width: 120,
            dataIndex: 'deliveryMethodName',
        }, {
            title: '是否直发',
            width: 80,
            dataIndex: 'isDirect',
            render: (text) => {
                if (text === null) {
                    return ""
                } else {
                    return text ? "是" : "否"
                }
            }
        }, {
            title: '备注',
            width: 160,
            dataIndex: 'note',
        }, {
            title: '打印次数',
            width: 80,
            // fixed: "right",
            align: "center",
            dataIndex: 'printingTimes',
        },
        {
            title: '所属站点',
            width: 250,
            fixed: "right",
            dataIndex: 'shopName',
            render: (text: any) => <YhTootip text={text} style={{ width: 250 }} />,
        },
    ];

    const roleColumns = useMemo(() => {
        //根据可视化配置处理需要展示相关列
        const params = { "code": "purchasePlan", "roleCodes": roles };
        return getRoleColumns("purchasePlan", "主单", defaultColumns, params);
    }, [roles, dataSource]);
    //点击行选高亮
    const onRow = (record: IPurchasePlanFields) => {
        let { id } = record as { id: string }
        let findIndexDesc = descRows.findIndex((item) => (item.id === id))
        let findIndexRowKeys = selectedRowKeys.findIndex((item) => (item === id))

        let newDescRows = [...descRows];
        let newSelectedRowKeys = [...selectedRowKeys];
        console.log(findIndexDesc)
        if (findIndexDesc === -1) {
            //统计数据
            newDescRows.push(record)
            setDescRows(newDescRows)
            //表格选中行Key值
            newSelectedRowKeys.push(id);
            setSelectedRowKeys(newSelectedRowKeys);
        } else {
            //统计数据
            newDescRows.splice(findIndexDesc, 1);
            setDescRows(newDescRows);
            //表格选中行Key值
            newSelectedRowKeys.splice(findIndexDesc, 1);
            setSelectedRowKeys(newSelectedRowKeys);
        }
        // let findIndex = selectedRowKeys.indexOf(id);
        // let newSelectedRowKeys = [...selectedRowKeys];
        // if (findIndex === -1) {
        //     newSelectedRowKeys.push(id);
        //     setSelectedRowKeys(newSelectedRowKeys);
        // } else {
        //     newSelectedRowKeys.splice(findIndex, 1);
        //     setSelectedRowKeys(newSelectedRowKeys);
        // }
    };
    const onRightClick = (record: IPurchasePlanFields) => {
        setDescRows([record])
        setSelectedRowKeys([record.id as string])
    }
    return (
        <Table
            bordered
            style={{ cursor: "pointer" }}
            size={tableSize}
            rowKey={record => record.id as string}
            rowSelection={{
                type: "checkbox",
                onChange: (selectedRowKeys: React.Key[], selectedRows: IPurchasePlanFields[]) => {
                    setSelectedRowKeys(selectedRowKeys as string[]);
                    setDescRows(selectedRows)
                },
                selectedRowKeys: selectedRowKeys
            }}
            columns={roleColumns.map(column => {
                // 如果是需要变色的列，添加 onCell 属性
                if (column.dataIndex === 'unarrivedNum') { // 替换为实际需要变色的列的 dataIndex
                    return {
                        ...column,
                        onCell: (record: any) => ({
                            style: {
                                backgroundColor: record.queryType === 3 ? '#ffcc17' : '',
                            },
                        }),
                    };
                }
                return column;
            })}
            dataSource={dataSource}
            pagination={{
                showSizeChanger: true,
                ...pgCfg,
                defaultPageSize: 25,
                pageSizeOptions: ['15', '25', '50', '100', '200', '500'],
                position: ["bottomRight"],
                showTotal: () => `共${pgCfg.total}条`,
                onChange: (pageNum, pageSize) => {
                    loadData({ pageNum, pageSize }).then();
                }
            }}
            onRow={record => ({
                // onClick: () => onRow(record.id as string),
                onClick: () => onRow(record),
                onContextMenu: (e) => {
                    e.preventDefault();
                    onRightClick(record)
                }

            })}
            scroll={{ x: 'max-content', y: 'calc(100vh - 370px)' }}
            summary={() => (
                <Table.Summary fixed>
                    <Table.Summary.Row className="table-total-box">
                        <Table.Summary.Cell index={0}>
                            <div className="title">合计</div>
                        </Table.Summary.Cell>
                        <Table.Summary.Cell index={1} />
                        <Table.Summary.Cell index={2} />
                        <Table.Summary.Cell index={3} />
                        <Table.Summary.Cell index={4} />
                        <Table.Summary.Cell index={5} />
                        <Table.Summary.Cell index={6} />
                        <Table.Summary.Cell index={7} />
                        <Table.Summary.Cell index={8} />
                        <Table.Summary.Cell index={9} />
                        <Table.Summary.Cell index={10} >
                            <span className="red">{selectedRowKeys.length === 0 ? descTotal.totalNum : rowsDescTotal.totalNum}</span>
                        </Table.Summary.Cell>
                        <Table.Summary.Cell index={11} />
                        {/* >
                            <span className="red">{formatNum(selectedRowKeys.length === 0 ? descTotal.totalAmount : rowsDescTotal.totalAmount)}</span>
                        </Table.Summary.Cell> */}
                        <Table.Summary.Cell index={12} />
                        <Table.Summary.Cell index={13} />
                        <Table.Summary.Cell index={14} />
                        <Table.Summary.Cell index={15} />
                        <Table.Summary.Cell index={16} />
                        <Table.Summary.Cell index={17} />
                    </Table.Summary.Row>
                </Table.Summary>
            )}
        />
    )
}
